import {axiosInstance} from "../instance";

const InvestmentList = () => {
    return axiosInstance.get('/api/investment');
}

const InvestmentSave = (building) => {
    return axiosInstance.post('/api/investment', building);
}

const InvestmentGet = (buildingId) => {
    return axiosInstance.get(`/api/investment/${buildingId}`);
}

const ActiveInvestmentList = () => {
    return axiosInstance
        .get('/api/investment/active');
}

const InvestmentStatement = (investmentId, dateFrom, dateTo) => {
     if (!!dateFrom && !!dateTo) {
         return axiosInstance.get(`/api/investment/${investmentId}/statement/${dateFrom}/${dateTo}`);
     } else if (!!dateFrom) {
         return axiosInstance.get(`/api/investment/${investmentId}/statement/${dateFrom}`);
     }

     return axiosInstance.get(`/api/investment/${investmentId}/statement`);
};

const SendInvestmentStatement = ($investmentId, attachment) => {
    return axiosInstance.post(`/api/investment-send-statement/${$investmentId}`, attachment, {headers: {'Content-Type': 'multipart/form-data'}})
}

const InvestmentStatementServices = (investmentId) => {
    return axiosInstance.get(`/api/available-services/${investmentId}`);
}

export {InvestmentList, InvestmentGet, InvestmentSave, InvestmentStatement, ActiveInvestmentList, SendInvestmentStatement, InvestmentStatementServices};
